import axios from "axios";
import config from "../config";
const fetchApiProducts = async ({ term_id, filterCategories, filterTags, filterPrice, filterVars, filterLang, env, elastic_index, archive_sort }) => {
    console.log(config);
    const result = await axios.post(`${config.api_url[env]}/api-elastic/${elastic_index}/get_products/${env}-post-product/_search`, {
        term_id,
        filterCategories,
        filterTags,
        filterPrice,
        filterVars,
        filterLang,
        env,
        elastic_index,
        archive_sort
    });
    console.log(`${config.api_url[env]}/api-elastic/${elastic_index}/get_products/${env}-post-product/_search`, {
        term_id,
        filterCategories,
        filterTags,
        filterPrice,
        filterVars,
        filterLang,
        env,
        elastic_index,
        archive_sort
    });
    return result.data;
};
export { fetchApiProducts };
